/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { _date } from '@mairistem/administres-utils';
import { Table } from '@mairistem/composants';

import type { Acte } from '@/types';
import { formatHeure, trimComma } from '@/utils';

interface Props {
  acte: Acte;
}

const ActeTableLineDeces = ({ acte }: Props) => {
  // Sans heure connue, la date seule : « 00:00 » se confondrait avec minuit.
  const heure = formatHeure(acte.heureDeces, acte.minuteDeces);
  const dateDeces = [_date.short(acte.dateDeces ?? ''), heure]
    .filter(Boolean)
    .join(' - ');

  return (
    <>
      <Table.Cell content={dateDeces} />
      <Table.Cell content={trimComma(acte.nomClassementDefunt)} />
    </>
  );
};

export default ActeTableLineDeces;
